import { useContext } from 'react';
import { FeatureFlagsContext } from '../providers/FeatureFlagsProvider';

export default function useFeatureFlags() {
    const context = useContext(FeatureFlagsContext);
    if (!context) {
        throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
    }
    return context;
}
